module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0BAMAAAA3VgbYAAAAAXNSR0IArs4c6QAAAB5QTFRFAAAAgoKCgICDfn6Bfn6BfoCBfn6BfX+Afn6BfX6AejZePAAAAAl0Uk5TACtAV3+Avr/AI9rKbwAAAIdJREFUOMtjYCALqIaiAgWEVORMVBBAnNQMsDnhM0tBVASK1FQwxTLTAUSxDpSUsCGyFKOxAEagQKWwgUEmpYoZcTCpSMzYIUZqBiTuIrBITYWwWQdWChR9IDZSxCEHFFqgjUoNdykXIHCbmQIkHcA8EBsqiSigJsB5EwhKucCBA5zngLcQBQCHgp9xsks+KwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/assets/images/title-text-icon.png
// module id = SB66
// module chunks = 241